import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.join";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/web.url";
import "core-js/modules/web.url.to-json";
import _isArray from "lodash/isArray";
import _isObject from "lodash/isObject";
import _isString from "lodash/isString";
import _each from "lodash/each";
import globals from "web/script/modules/globals";

URLSearchParams.prototype.toJSON = function () {
  var result = {};
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = this.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _key = _step.value;
      result[_key] = this.getAll(_key);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return result;
};

URLSearchParams.prototype.deleteValue = function deleteValue(name, valueToRemove) {
  if (!this.has(name)) {
    return;
  }

  var existing = this.getAll(name);
  this.delete(name);
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = existing[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var value = _step2.value;

      if (value != valueToRemove) {
        this.append(name, value);
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
};
/**
 * Joins all arguments together ensuring there is a leading and trailing slash.
 * Any arguments that not non-empty strings are ignored.
 */


export function join() {
  for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
    args[_key2] = arguments[_key2];
  }

  var result = "/".concat(args.filter(function (s) {
    return !!s;
  }).join("/"), "/").replace(/\/+/g, "/");

  if (result == "/") {
    return "";
  }

  return result;
}
/**
 * Turns a URLSearchParams instance or a plain object into an encoded query string.
 */

export function toQueryString(params) {
  if (params instanceof URLSearchParams) {
    return params.toString();
  }

  var searchParams = new URLSearchParams();

  _each(params, function (value, key) {
    if (_isArray(value)) {
      value.forEach(searchParams.append.bind(searchParams, key));
    } else if (value != null) {
      searchParams.append(key, value);
    }
  });

  return searchParams.toString();
}
/**
 * Unparses an object with the same structure as returned from `parse` and returns a string.
 * For flexibility the `searchParams` property can be a URLSearchParams instance or just a plain object.
 */

export function unparse(parsed) {
  var url = "";
  var queryString = toQueryString(parsed.searchParams);
  url += parsed.protocol ? parsed.protocol + "//" : "";
  url += parsed.host || "";
  url += parsed.path || "";
  url += queryString ? "?" + queryString : "";
  url += parsed.hash || "";
  return url;
}
/**
 * Parses a URL into an object. The returns object can be mutated to change the URL and
 * then passed to `unparse` to get a URL string again.
 */

export function parse(url) {
  var parsedURL = new URL(url, globals.window.location.href);
  var parsed = {
    protocol: parsedURL.protocol,
    host: parsedURL.host,
    searchParams: parsedURL.searchParams,
    path: parsedURL.pathname,
    hash: parsedURL.hash
  };
  parsed.toString = unparse.bind(null, parsed);
  return parsed;
}
/**
 * Creates a URLSearchParams instance from `obj`.
 */

export function toURLSearchParams(obj) {
  if (obj instanceof URLSearchParams) {
    return obj;
  }

  if (_isString(obj)) {
    return new URLSearchParams(obj.replace(/^\?/, ""));
  }

  if (_isObject(obj) && !_isArray(obj)) {
    return new URLSearchParams(toQueryString(obj));
  }

  return new URLSearchParams();
}
export default {
  URLSearchParams: URLSearchParams,
  join: join,
  parse: parse,
  unparse: unparse,
  toQueryString: toQueryString,
  toURLSearchParams: toURLSearchParams
};